import { InjectionToken, Inject, Injectable, APP_INITIALIZER, NgModule, defineInjectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
const /** @type {?} */ CONFIG_MANAGER_SERVICE_CONFIGURATION = new InjectionToken('config-manager-service-configuration.config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ConfigManagerService {
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
        this._mockArrayTest = /^\[.*]$/g;
        this.configuredSubject = new BehaviorSubject(undefined);
        this.configured$ = this.configuredSubject.asObservable();
    }
    /**
     * @template T
     * @return {?}
     */
    getSettings() {
        if (!this._settings) {
            return undefined;
        }
        return /** @type {?} */ (this._settings);
    }
    /**
     * @template T
     * @param {?} propertyName
     * @return {?}
     */
    getSetting(propertyName) {
        if (!this._settings) {
            return undefined;
        }
        return /** @type {?} */ (this._settings[propertyName]);
    }
    /**
     * @template T
     * @param {?} propertyName
     * @param {?} value
     * @return {?}
     */
    setSetting(propertyName, value) {
        if (this._settings) {
            this._settings[propertyName] = value;
        }
    }
    /**
     * @return {?}
     */
    init() {
        return Observable.create(observer => {
            const /** @type {?} */ xhr = new XMLHttpRequest();
            xhr.open('GET', this.config.configFileUrl);
            xhr.addEventListener('readystatechange', () => {
                if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                    this._settings = this.parseArray(JSON.parse(xhr.responseText));
                    this.configuredSubject.next(this._settings);
                    observer.next(this._settings);
                }
                else if (xhr.readyState === XMLHttpRequest.DONE) {
                    observer.errback(new Error('Unknown error state'));
                }
            });
            xhr.send(null);
        });
    }
    /**
     * @param {?} settings
     * @return {?}
     */
    parseArray(settings) {
        if (settings) {
            Object.keys(settings).forEach(key => {
                if (settings[key]['match'] && settings[key].match(this._mockArrayTest)) {
                    settings[key] = (settings[key].length === 2)
                        ? []
                        : settings[key].substring(1, settings[key].length - 1).split('|');
                }
            });
        }
        return settings;
    }
}
ConfigManagerService.ɵfac = function ConfigManagerService_Factory(t) { return new (t || ConfigManagerService)(ɵngcc0.ɵɵinject(CONFIG_MANAGER_SERVICE_CONFIGURATION)); };
ConfigManagerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ConfigManagerService, factory: ConfigManagerService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ConfigManagerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CONFIG_MANAGER_SERVICE_CONFIGURATION,] }] }
];
/** @nocollapse */ ConfigManagerService.ngInjectableDef = defineInjectable({ factory: function ConfigManagerService_Factory() { return new ConfigManagerService(inject(CONFIG_MANAGER_SERVICE_CONFIGURATION)); }, token: ConfigManagerService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfigManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [CONFIG_MANAGER_SERVICE_CONFIGURATION]
            }] }]; }, null); })();
/**
 * @param {?} configManager
 * @return {?}
 */
function configAppSettings(configManager) {
    return () => {
        return new Promise((resolve) => {
            configManager.init().subscribe(settings => {
                resolve(settings);
            });
        });
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = configAppSettings;
class ConfigManagerModule {
}
ConfigManagerModule.ɵfac = function ConfigManagerModule_Factory(t) { return new (t || ConfigManagerModule)(); };
ConfigManagerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ConfigManagerModule });
ConfigManagerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: APP_INITIALIZER, useFactory: ɵ0, deps: [ConfigManagerService], multi: true },
    ], imports: [[CommonModule, HttpClientModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfigManagerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, HttpClientModule],
                providers: [
                    { provide: APP_INITIALIZER, useFactory: ɵ0, deps: [ConfigManagerService], multi: true },
                ],
                exports: [],
                declarations: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ConfigManagerModule, { imports: function () { return [CommonModule, HttpClientModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { CONFIG_MANAGER_SERVICE_CONFIGURATION, configAppSettings, ConfigManagerService, ConfigManagerModule };

